export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/jordan-profile-19c481041088dd678dd331cc5dc301ac.png";